import type { FechaISO } from '../modelo/tipos';

const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
const LETRAS_DIA = ['D', 'L', 'M', 'X', 'J', 'V', 'S'];

const dos = (n: number) => (n < 10 ? '0' : '') + n;

/** Fecha local en formato AAAA-MM-DD, `dias` días antes de `hoy`. */
export function isoHace(dias: number, hoy: Date = new Date()): FechaISO {
  const d = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
  d.setDate(d.getDate() - dias);
  return d.getFullYear() + '-' + dos(d.getMonth() + 1) + '-' + dos(d.getDate());
}

/** «Hoy», «Ayer» o «21 oct 2026». Cadena vacía → «Fecha desconocida». */
export function formatearFecha(iso: FechaISO, hoy: Date = new Date()): string {
  if (!iso) return 'Fecha desconocida';
  if (iso === isoHace(0, hoy)) return 'Hoy';
  if (iso === isoHace(1, hoy)) return 'Ayer';
  const [a, m, d] = iso.split('-');
  return parseInt(d, 10) + ' ' + MESES[parseInt(m, 10) - 1] + ' ' + a;
}

export interface DiaSemana {
  iso: FechaISO;
  letra: string;
  numero: number;
}

/** Los últimos 7 días, del más antiguo a hoy. */
export function ultimosSieteDias(hoy: Date = new Date()): DiaSemana[] {
  const dias: DiaSemana[] = [];
  for (let i = 6; i >= 0; i--) {
    const d = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - i);
    dias.push({ iso: isoHace(i, hoy), letra: LETRAS_DIA[d.getDay()], numero: d.getDate() });
  }
  return dias;
}

export function saludo(hoy: Date = new Date()): string {
  const h = hoy.getHours();
  return h < 6 ? 'Buenas noches' : h < 13 ? 'Buenos días' : h < 20 ? 'Buenas tardes' : 'Buenas noches';
}

export function fechaLarga(hoy: Date = new Date()): string {
  try {
    return hoy.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
  } catch {
    return '';
  }
}

export function nuevoId(prefijo: string): string {
  return prefijo + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
}
